import { STORAGE_KEYS } from '../omnidashboard.config';
import * as i0 from "@angular/core";
var OmnidashboardStorageService = /** @class */ (function () {
    function OmnidashboardStorageService() {
    }
    OmnidashboardStorageService.prototype.hasLoginData = function () {
        return !!this.getItem(this.getLocalStorage(), STORAGE_KEYS.loginData);
    };
    OmnidashboardStorageService.prototype.isLogoutRequested = function () {
        return this.getItem(this.getLocalStorage(), STORAGE_KEYS.logOutFlag) === 'true';
    };
    OmnidashboardStorageService.prototype.getLoginDataRaw = function () {
        return this.getItem(this.getLocalStorage(), STORAGE_KEYS.loginData);
    };
    OmnidashboardStorageService.prototype.getAdminRoleId = function () {
        return this.getItem(this.getLocalStorage(), STORAGE_KEYS.adminId);
    };
    OmnidashboardStorageService.prototype.getSelectedFiscalYear = function () {
        return this.getItem(this.getSessionStorage(), STORAGE_KEYS.omniFiscalYear);
    };
    OmnidashboardStorageService.prototype.setSelectedFiscalYear = function (fiscalYear) {
        this.setItem(this.getSessionStorage(), STORAGE_KEYS.omniFiscalYear, fiscalYear);
    };
    OmnidashboardStorageService.prototype.setSelectedChapterId = function (chapterId) {
        this.setItem(this.getLocalStorage(), STORAGE_KEYS.chapterId, chapterId);
    };
    OmnidashboardStorageService.prototype.getLocalStorage = function () {
        try {
            return typeof window !== 'undefined' ? window.localStorage : null;
        }
        catch (_a) {
            return null;
        }
    };
    OmnidashboardStorageService.prototype.getSessionStorage = function () {
        try {
            return typeof window !== 'undefined' ? window.sessionStorage : null;
        }
        catch (_a) {
            return null;
        }
    };
    OmnidashboardStorageService.prototype.getItem = function (storage, key) {
        if (!storage) {
            return null;
        }
        try {
            return storage.getItem(key);
        }
        catch (_a) {
            return null;
        }
    };
    OmnidashboardStorageService.prototype.setItem = function (storage, key, value) {
        if (!storage) {
            return;
        }
        try {
            storage.setItem(key, value);
        }
        catch (_a) {
            // Ignore quota/private-mode failures; reads already return null safely.
        }
    };
    OmnidashboardStorageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OmnidashboardStorageService_Factory() { return new OmnidashboardStorageService(); }, token: OmnidashboardStorageService, providedIn: "root" });
    return OmnidashboardStorageService;
}());
export { OmnidashboardStorageService };
